import _ from 'lodash';
import { STATUS_INIT, STATUS_SUCCESS, STATUS_FAILURE } from 'constants/status';
import * as NOTIFICATIONS from 'constants/notifications';
import { joinInNodeRoom } from 'modules/socket/actions';
import { ROOM_THEME_TABLE } from 'constants/rooms';
import * as ACTION_TYPE from './types';

const INITIAL_STATE = {
  myThinkChatsList: null,
  myThinkChatsStatus: null,
  narrativesThinkChats: {}, 
  narrativesThinkChatsStatus: {},
  userNarrativesThinkChats: {}, 
  userNarrativesThinkChatsStatus: {},
};

const handleModalNotifications = (state, notification) => {
  switch (notification.req_message) {
    case NOTIFICATIONS.NEW_TABLE_JOINED: {
      const table = JSON.parse(notification.table);
      const myThinkChatsList = state.myThinkChatsList ? [...state.myThinkChatsList] : null;
      if (myThinkChatsList && !_.find(myThinkChatsList, { id: table.id })) {
        myThinkChatsList.push(table);
        joinInNodeRoom(ROOM_THEME_TABLE, table.id);
      }

      return {
        ...state,
        myThinkChatsList,
      };
    }
    case NOTIFICATIONS.THINK_CHAT_UPDATED: {
      const data = JSON.parse(notification.data);
      const userId = notification.user_id;
      const isMember = !!_.find(data.users, { id: userId });
      const { myThinkChatsList } = state;
      if (myThinkChatsList) {
        const index = _.findIndex(myThinkChatsList, { id: data.id });
        if (isMember) {
          if (index >= 0) {
            myThinkChatsList[index] = data;
          } else {
            myThinkChatsList.push(data);
          }
        } else {
          _.remove(myThinkChatsList, { id: data.id });
        }
      }
      return {
        ...state,
        myThinkChatsList,
      };
    }
    default:
      break;
  }

  return state;
};

export default function thinkChatsReducer(state = INITIAL_STATE, action) {
  const { type, payload } = action;

  switch (type) {
    case ACTION_TYPE.NOTIFICATION:
    case ACTION_TYPE.NOTIFICATION_TO_ROOM:
      return handleModalNotifications(state, payload);
    case ACTION_TYPE.GET_MY_THINK_CHATS_DATA_INIT:
      return {
        ...state,
        myThinkChatsList: [],
        myThinkChatsStatus: STATUS_INIT,
      };
    case ACTION_TYPE.GET_MY_THINK_CHATS_DATA_SUCCESS:
      return {
        ...state,
        myThinkChatsList: [...payload.data],
        myThinkChatsStatus: STATUS_SUCCESS,
      };
    case ACTION_TYPE.GET_MY_THINK_CHATS_DATA_FAILURE:
      return {
        ...state,
        myThinkChatsList: [],
        myThinkChatsStatus: STATUS_FAILURE,
      };
    case ACTION_TYPE.LEAVE_THINK_CHAT: {
      const myThinkChatsList = _.filter(state.myThinkChatsList, chat => chat.chat_id !== payload.params.chatId);

      return {
        ...state,
        myThinkChatsList,
      };
    }
    case ACTION_TYPE.JOIN_THINK_CHAT: {
      const myThinkChatsList = [...state.myThinkChatsList];

      if (!_.find(myThinkChatsList, { id: payload.id })) {
        myThinkChatsList.push(payload);
      }

      return {
        ...state,
        myThinkChatsList: [...myThinkChatsList],
      };
    }
    case ACTION_TYPE.UPDATE_THINK_CHAT: {
      const myThinkChatsList = [...state.myThinkChatsList];

      const index = _.findIndex(myThinkChatsList, { id: payload.id });
      if (index) {
        myThinkChatsList[index] = payload;
      }

      return {
        ...state,
        myThinkChatsList,
      };
    }
    case ACTION_TYPE.GET_NARRATIVES_THINK_CHATS_INIT: {
      const { narrativesThinkChats, narrativesThinkChatsStatus } = state;
      const { narrativeId } = payload;

      narrativesThinkChats[narrativeId] = null;
      narrativesThinkChatsStatus[narrativeId] = STATUS_INIT;

      return {
        ...state,
        narrativesThinkChats,
        narrativesThinkChatsStatus,
      };
    }
    case ACTION_TYPE.GET_NARRATIVES_THINK_CHATS_SUCCESS: {
      const { narrativesThinkChats, narrativesThinkChatsStatus } = state;
      const { narrativeId, thinkChats } = payload;

      narrativesThinkChats[narrativeId] = thinkChats;
      narrativesThinkChatsStatus[narrativeId] = STATUS_SUCCESS;

      return {
        ...state,
        narrativesThinkChats,
        narrativesThinkChatsStatus,
      };
    }
    case ACTION_TYPE.GET_NARRATIVES_THINK_CHATS_FAILURE: {
      const { narrativesThinkChats, narrativesThinkChatsStatus } = state;
      const { narrativeId } = payload;

      narrativesThinkChats[narrativeId] = null;
      narrativesThinkChatsStatus[narrativeId] = STATUS_FAILURE;

      return {
        ...state,
        narrativesThinkChats,
        narrativesThinkChatsStatus,
      };
    }
    case ACTION_TYPE.GET_USER_NARRATIVES_THINK_CHATS_INIT: {
      const { userNarrativesThinkChats, userNarrativesThinkChatsStatus } = state;
      const { narrativeId } = payload;

      userNarrativesThinkChats[narrativeId] = null;
      userNarrativesThinkChatsStatus[narrativeId] = STATUS_INIT;

      return {
        ...state,
        userNarrativesThinkChats,
        userNarrativesThinkChatsStatus,
      };
    }
    case ACTION_TYPE.GET_USER_NARRATIVES_THINK_CHATS_SUCCESS: {
      const { userNarrativesThinkChats, userNarrativesThinkChatsStatus } = state;
      const { narrativeId, thinkChats } = payload;

      userNarrativesThinkChats[narrativeId] = thinkChats;
      userNarrativesThinkChatsStatus[narrativeId] = STATUS_SUCCESS;

      return {
        ...state,
        userNarrativesThinkChats,
        userNarrativesThinkChatsStatus,
      };
    }
    case ACTION_TYPE.GET_USER_NARRATIVES_THINK_CHATS_FAILURE: {
      const { userNarrativesThinkChats, userNarrativesThinkChatsStatus } = state;
      const { narrativeId } = payload;

      userNarrativesThinkChats[narrativeId] = null;
      userNarrativesThinkChatsStatus[narrativeId] = STATUS_FAILURE;

      return {
        ...state,
        userNarrativesThinkChats,
        userNarrativesThinkChatsStatus,
      };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/modules/think-seeds/index.js